import { instance } from '@/libs/api/instance'

/**
 *
 * @param {number} id - beneficiary id
 * @param {string } name - name of beneficiary
 * @param {boolean|number} validate - should be validated
 * @return {Promise<AxiosResponse<any>>}
 */

export const updateBeneficiary = async (id, { name }, { validate }) => {
  return instance.patch(
    `/v1/beneficiary/${id}`,
    { name },
    { params: { validate: Number(validate) } },
  )
}
